import React, { useEffect, useRef } from "react";
import withContext from "../../utils/withContext";
import { useAdRefresh } from "../../utils/adRefresh";

export const AdFoxAdaptive = ({ options, context, cls = true, className = "adfox", refresh = true }) => {
    const first = options && options[0];
    const ref = useRef(null);
    // У adfox блок обновляется и при уходе из экрана — так рефреш работал в template48306_new.
    const round = useAdRefresh(ref, { enabled: refresh && Boolean(first), refreshOnLeave: true });

    useEffect(() => {
        if (!first || typeof window === "undefined" || !window.yaContextCb) {
            return;
        }

        // Копируем и сам элемент, и params: `[...options]` копирует только массив,
        // поэтому запись partner-stat-id уходила в объект исходного конфига.
        // С конфигом из window.initial это была бы мутация общего состояния страницы.
        // Спред отсутствующего params даёт {}, поэтому yandex-payload больше не падает
        // на `Cannot set properties of undefined (setting 'partner-stat-id')`.
        const opts = [
            { ...first, params: { ...first.params, "partner-stat-id": context.uniq_id } },
            ...options.slice(1),
        ];

        if (round && ref.current) {
            ref.current.innerHTML = "";
        }

        window.yaContextCb.push(() => {
            window.Ya.adfoxCode.create(...opts);
        });
    }, [options, context.uniq_id, round]);

    if (!first) {
        return null;
    }

    return <div ref={ref} id={first.containerId} {...(cls ? { className: className } : {})} />;
};

export default withContext(AdFoxAdaptive);
